import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebsiteComponent } from './website.component';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';

import { ShowPageComponent } from './show-page-component/show-page.component';
import { WebSiteService } from './services/website-service';
import { DetailComponent } from './show-page-component/detail-component/detail.component';
import { FormsModule } from '@angular/forms';
import { ContactPageComponent } from './contact-us/contact-page.component';
import { AgmCoreModule } from '@agm/core';
import { RecaptchaModule } from 'angular-google-recaptcha';
import { HttpClientModule } from '@angular/common/http';
import { SearchPageComponent } from './search-page-component/search-page.component';
import { CoreModule } from '../core/core.module';

const routes = [
  {
    path: '',
    component: WebsiteComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'page/:id',
        component: ShowPageComponent
      },
      {
        path: 'contact-us',
        component: ContactPageComponent
      },
      {
        path: 'search',
        component: SearchPageComponent
      }
    ]
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    HttpClientModule,
    RouterModule.forChild(routes),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBVR5XE8z6VCBOMFkp4iCTQ19Hsn1hosvY'
    }),
    RecaptchaModule.forRoot({
      siteKey: '6LcWsKsUAAAAACrJEgyz-0sjpF8HYVszQ_tTtgs1',
  }),
  ],
  declarations: [
    WebsiteComponent,
    HomeComponent,
    NavMenuComponent,
    ShowPageComponent,
    DetailComponent,
    ContactPageComponent,
    ShowPageComponent,
    SearchPageComponent
  ],
  providers: [
    WebSiteService,
  ]
})
export class WebsiteModule { }
